export const BEAUTY_SNS_LAB_TENANT_KEY = "beauty-sns-lab";
export const BEAUTY_SNS_LAB_DOMAIN = "beauty-sns-labo.jp";
export const BEAUTY_SNS_LAB_ORIGIN = `https://${BEAUTY_SNS_LAB_DOMAIN}`;

export const BEAUTY_SNS_LAB_ASSETS = {
  logoBadge: "/beauty-sns-lab/logo-badge.png",
  logoHorizontal: "/beauty-sns-lab/logo-horizontal.png",
  logoStacked: "/beauty-sns-lab/logo-stacked.png",
  hero: "/beauty-sns-lab/brand-hero.jpg",
};

export const BEAUTY_SNS_LAB_BRAND = {
  name: "美容SNSラボ",
  tagline: "「美容好き」から「ビューティークリエイター」へ！",
  logo_url: BEAUTY_SNS_LAB_ASSETS.logoHorizontal,
  favicon_url: BEAUTY_SNS_LAB_ASSETS.logoBadge,
  og_image_url: BEAUTY_SNS_LAB_ASSETS.hero,
};

export const BEAUTY_SNS_LAB_THEME = {
  primary_color: "#FF75A8",
  secondary_color: "#6FD6D0",
  font_family: "Noto Sans JP",
};

export const BEAUTY_SNS_LAB_FEATURE_FLAGS = {
  payment_enabled: false,
  line_enabled: false,
  vision_api_enabled: true,
  human_escalation_enabled: false,
  analytics_enabled: true,
  public_signup_enabled: false,
  score_display_enabled: false,
};

export const BEAUTY_SNS_LAB_FALLBACK_CONFIG = {
  tenant_key: BEAUTY_SNS_LAB_TENANT_KEY,
  brand: BEAUTY_SNS_LAB_BRAND,
  theme: BEAUTY_SNS_LAB_THEME,
  domain: BEAUTY_SNS_LAB_DOMAIN,
  feature_flags: BEAUTY_SNS_LAB_FEATURE_FLAGS,
  support: {
    email: null,
    company_name: BEAUTY_SNS_LAB_BRAND.name,
    help_url: null,
  },
  legal: {
    terms_url: null,
    privacy_url: null,
  },
};

type TenantLike = {
  tenant_key?: string | null;
  domain?: string | null;
  brand?: {
    name?: string | null;
  } | null;
};

export function normalizeHostname(hostname?: string | null): string {
  return (hostname ?? "").trim().toLowerCase().replace(/^www\./, "");
}

export function isBeautySnsLabHost(hostname?: string | null): boolean {
  const normalized = normalizeHostname(hostname);
  return (
    normalized === BEAUTY_SNS_LAB_DOMAIN ||
    normalized.endsWith(`.${BEAUTY_SNS_LAB_DOMAIN}`)
  );
}

export function isBeautySnsLabPath(pathname?: string | null): boolean {
  const normalized = (pathname ?? "").trim().toLowerCase().replace(/\/+$/, "");
  return normalized === "/beauty-sns-lab" || normalized.startsWith("/beauty-sns-lab/");
}

export function isBeautySnsLabTenantKey(value?: string | null): boolean {
  const normalized = (value ?? "").trim().toLowerCase();
  return normalized === BEAUTY_SNS_LAB_TENANT_KEY || normalized === "beauty_sns_lab";
}

export function isBeautySnsLabConfig(config?: TenantLike | null): boolean {
  if (!config) return false;

  const tenantKey = (config.tenant_key ?? "").trim().toLowerCase();
  const domain = normalizeHostname(config.domain);
  const brandName = (config.brand?.name ?? "").trim();

  return (
    isBeautySnsLabTenantKey(tenantKey) ||
    domain === BEAUTY_SNS_LAB_DOMAIN ||
    brandName === BEAUTY_SNS_LAB_BRAND.name
  );
}

export function resolvePublicAssetUrl(value?: string | null, origin?: string): string | undefined {
  if (!value) return undefined;
  if (/^https?:\/\//i.test(value)) return value;

  const base =
    origin ||
    (typeof window !== "undefined" && window.location?.origin) ||
    BEAUTY_SNS_LAB_ORIGIN;

  return new URL(value, base).toString();
}
